
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://cpifilgemquezhiylcfg.supabase.co';
const supabaseKey = 'sb_publishable_sRQBX_O-7sXPqg1Naj-LBw_TiZZROOd';

export const supabase = createClient(supabaseUrl, supabaseKey);
